module.exports = __webpack_public_path__ + "static-portal/img/custom-zf.99580d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-zf.jpg
// module id = 56GQ
// module chunks = 4